/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PagarMeAddressResponse } from './pagarMeAddressResponse';
import { PagarMeTransactionResponsePhoneObject } from './pagarMeTransactionResponsePhoneObject';

export interface PagarMeCustomerResponse {
  address?: PagarMeAddressResponse;
  birthdate?: string;
  code?: string;
  createdAt?: string;
  delinquent?: boolean;
  document?: string;
  documentType?: string;
  email?: string;
  gender?: string;
  id?: string;
  metadata?: { [key: string]: string };
  name?: string;
  phones?: PagarMeTransactionResponsePhoneObject;
  type?: string;
  updatedAt?: string;
}
